module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "cats"
  }, [_c('h2', [_vm._v("Unique Kitties")]), _vm._v(" "), _c('div', {
    ref: "catref"
  }, _vm._l((_vm.cats), function(cat) {
    return _c('cat', {
      attrs: {
        "cat": cat
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e558a80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cats/Unique.vue
// module id = 128
// module chunks = 2